module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLoading) ? _c('div', [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "color": "#6666ff",
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "is-fullhd"
  }, [(_vm.$cookie.get('role') === 'superAdmin' || _vm.$cookie.get('role') === 'companyAdmin') ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-5"
  }, [_c('chart', {
    attrs: {
      "id": "summyryChart",
      "type": 'bar',
      "data": _vm.chartData,
      "options": _vm.options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-7"
  }, [_c('div', {
    staticClass: "table-container teamSummaryTable"
  }, [_c('small', {
    staticClass: "has-text-grey-light is-pulled-right"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.previewModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Reminder Preview\n                  ")])]), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered is-narrow is-fullwidth"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedMembers), function(member) {
    return _c('tr', [_c('td', [_vm._v("\n                        " + _vm._s(member.member) + "\n                      ")]), _vm._v(" "), (member.status === 1) ? _c('td', [_vm._m(2, true), _vm._v("\n                        Invited (not joined)\n                      ")]) : _vm._e(), _vm._v(" "), (member.status === 2) ? _c('td', [_vm._m(3, true), _vm._v("\n                        Assessment pending\n                      ")]) : _vm._e(), _vm._v(" "), (member.status === 3) ? _c('td', [_vm._m(4, true), _vm._v("\n                        Assessment Submitted\n                      ")]) : _vm._e(), _vm._v(" "), (member.action) ? _c('td', [_c('button', {
      staticClass: "button is-primary is-small"
    }, [_c('i', {
      staticClass: "fa fa-bell",
      on: {
        "click": function($event) {
          return _vm.remind(member)
        }
      }
    }, [_vm._v(" Remind")])])]) : _vm._e(), _vm._v(" "), (!member.action) ? _c('td', [_vm._m(5, true)]) : _vm._e()])
  }), 0)])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n              Assessment Dashboard\n            ")]), _vm._v(" "), (_vm.$cookie.get('role') === 'superAdmin' || _vm.$cookie.get('role') === 'companyAdmin') ? _c('button', {
    staticClass: "button is-primary is-outlined editInitiativeBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editInitiative()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _c('span', {
    staticClass: "is-hidden-mobile"
  }, [_vm._v(" Edit")])]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "table-container initiativeSummaryTable"
  }, [_c('table', {
    staticClass: "table is-bordered is-narrow is-fullwidth"
  }, [_c('tbody', [_c('tr', [_vm._m(6), _vm._v(" "), (!this.user.Submitted) ? _c('td', [_vm._m(7), _vm._v("\n                      Assessment pending - \n                      "), _c('a', {
    attrs: {
      "href": "/#/ChangeRiskAssessment"
    }
  }, [_vm._v("Do my Assessment")])]) : _vm._e(), _vm._v(" "), (this.user.Submitted) ? _c('td', [_vm._m(8), _vm._v("\n                      Assessment Submitted\n                  ")]) : _vm._e()]), _vm._v(" "), _c('tr', [_vm._m(9), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(this.initiative.deadline) + "\n                    ")])]), _vm._v(" "), _c('tr', [_vm._m(10), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(this.initiative.teamName) + "\n                  ")])]), _vm._v(" "), _c('tr', [_vm._m(11), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(this.initiative.teamLead) + "\n                  ")])]), _vm._v(" "), _c('tr', [_vm._m(12), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(this.initiative.name) + "\n                  ")])]), _vm._v(" "), _c('tr', [_vm._m(13), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(this.initiative.initiativeDetails) + "\n                    "), ((_vm.$cookie.get('role') === 'superAdmin' || _vm.$cookie.get('role') === 'companyAdmin') && !this.initiative.initiativeDetails) ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editInitiative()
      }
    }
  }, [_vm._v("Update initiative description")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_vm._m(14), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(this.client.companyName) + "  \n                    "), (_vm.$cookie.get('role') === 'superAdmin' || _vm.$cookie.get('role') === 'companyAdmin') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editInitiative()
      }
    }
  }, [_vm._v("Change logo")]) : _vm._e()])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal welcomeModal",
    class: {
      isActive: _vm.notVisited
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n            Welcome to ChangeVU Free Trial\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closeNotVisited()
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n          Welcome to ChangeVU’s implementation change risk assessment!\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Please note that you should complete your assessment without consultation with any of your team members!\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Thank you for using ChangeVU!\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal previewModal",
    class: {
      isActive: _vm.previewModalOpen
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box is-paddingless"
  }, [_c('div', {
    staticClass: "preview-header has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": "https://www.changevu.com/img/logo2x.png",
      "href": "https://www.changevu.com/",
      "alt": "ChangeVU",
      "width": "150px"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closePreviewModal()
      }
    }
  })]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "preview-body has-text-white"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "has-text-white"
  }, [_vm._v("\n              Reminder: Change Risk Assessment\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Hi there,\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n               You've been invited by " + _vm._s(this.initiative.teamLead) + " to a free change risk assessment."), _c('br'), _vm._v("\n               The deadline for completing the assessment is " + _vm._s(this.initiative.deadline) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Click the button below to login and run your assessment.\n            ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0rem !important"
    }
  }, [_vm._v("\n              Your team details:\n            ")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Team Name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.initiative.teamName))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Team Leader:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.initiative.teamLead))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Initiative name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.initiative.name))])])])])])]), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary teamMemberTitle"
  }, [_vm._v("\n              Team Member Dashboard\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "button is-primary is-outlined editTeamBtn",
    attrs: {
      "href": "/#/teamInfo"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _c('span', {
    staticClass: "is-hidden-mobile"
  }, [_vm._v(" Edit")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Member")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon",
    staticStyle: {
      "color": "#b5b5b5"
    }
  }, [_c('i', {
    staticClass: "fa fa-square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon",
    staticStyle: {
      "color": "#fce473"
    }
  }, [_c('i', {
    staticClass: "fa fa-square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon has-text-primary"
  }, [_c('i', {
    staticClass: "fa fa-square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-primary is-small",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }, [_vm._v(" Remind")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon",
    staticStyle: {
      "color": "#fce473"
    }
  }, [_c('i', {
    staticClass: "fa fa-square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon",
    staticStyle: {
      "color": "#6666ff"
    }
  }, [_c('i', {
    staticClass: "fa fa-square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_c('strong', [_vm._v("Due Date")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_c('strong', [_vm._v("Team")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_c('strong', [_vm._v("Team Lead")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_c('strong', [_vm._v("Initiative")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_c('strong', [_vm._v("Description")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_c('strong', [_vm._v("Organization")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-banner has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": "https://www.changevu.com/img/banners/blogs.jpg",
      "href": "https://www.changevu.com/",
      "alt": "ChangeVU"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-body-button"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary has-text-black"
  }, [_vm._v("Run Assessment")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-body has-text-white"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n              If you have any questions "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Click here.")]), _c('br'), _c('br'), _vm._v("\n              Thanks,"), _c('br'), _vm._v("ChangeVU Team\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-footer"
  }, [_c('div', {
    staticClass: "footer-img"
  }, [_c('img', {
    attrs: {
      "src": "https://x5n8g.mjt.lu/tplimg/x5n8g/b/xzs81/oi9i.jpeg",
      "alt": "Connect to better change navigation"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "has-text-centered"
  }, [_c('a', {
    staticStyle: {
      "color": "#9B9B9B"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Unsubscribe")]), _vm._v(" to stop receiving these emails from us."), _c('br'), _vm._v("\n            Straticom Technologies R&D, 931 Lake Drive North, Georgina, Ontario, L4P3E9"), _c('br'), _vm._v("\n            © 2020 Straticom Technologies R&D, all rights reserved.\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c432ed7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue
// module id = 375
// module chunks = 5